import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Chip, } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronLeft, User } from 'react-feather';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';

export default function FirmDetails() {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userID = useSelector((state_id) => state_id.auth.id);
    const token = useSelector((state_id) => state_id.auth.token);
    const { locationId } = location.state || {};
    const [formData, setFormData] = useState({
        location_name: '',
        address: '',
        city: '',
        country: '',
        states: { id: null, state_name: '' }, // Default values for state object
        zip_code: '',
        status: false, // Default as boolean
    });

    useEffect(() => {
        viewLocation(locationId)
    }, [locationId])

    const handleClickEdit = () => {
        navigate('/editlocation', { state: { locationId: locationId } });
    };
    const handleBack = () => {
        setTimeout(() => navigate('/location'));
    };

    const viewLocation = async (locationId) => {
        const input_token = `${locationId}`;
        const apiUrl = 'view_location'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            location_id: locationId,
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setFormData(prevState => ({
                    ...prevState,
                    location_name: data.locations.location_name,
                    address: data.locations.address,
                    city: data.locations.city,
                    country: data.locations.country,
                    states: { id: data.locations.states.state_id, state_name: data.locations.states.state_name, }, // Assuming `state_id` corresponds to `state_name`
                    zip_code: data.locations.zip_code,
                    isActive: !!data.locations.status, // Convert to boolean
                }));
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
                className="title_head"
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        view Business location Details
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/location"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Location List
                </Button>
            </Box>


            <Box className="card-box" p={3} sx={{ borderRadius: '8px', border: '1px solid var(--border-color)', m:3 }} >
                <Box
                   
                    className="sub-header title_head"
                >
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        Location View
                    </Typography>
                    <Typography
                        sx={{ fontWeight: 'bold' }}
                    >
                        Account status: <span sx={{ color: formData.isActive ? 'green' : 'red', backgroundColor: formData.isActive ? 'transparent' : 'red', display: 'inline-block', fontWeight: 'bold' }}>{formData.isActive ? 'Yes' : 'No'}</span>
                    </Typography>
                </Box>


                <Box >
                    <Grid container spacing={6}>
                        <Grid size={6}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Location Name :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.location_name}</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Location Address :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.address}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Country :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.country}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>State :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.states?.state_name}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>City :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.city}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Zip Code :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.zip_code}</Typography>
                        </Grid>
                    </Grid>


                    {/* Action Buttons */}
                    <Box display={'flex'} justifyContent={'center'} gap={2} mt={4}>
                        <Button variant="contained" color="primary" onClick={() => handleClickEdit()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}

                        >Edit Location Details</Button>
                        <Button variant="outlined" onClick={() => handleBack()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--back-button)',
                                color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' } }}
                        ><ChevronLeft size={24} /> Back to Location list</Button>
                    </Box>
                </Box>
            </Box>
        </Box>


    );
}
